module.exports = __webpack_public_path__ + "img/Bootstrap_(framework).4a48d8ea.png";